import { render, staticRenderFns } from "./SIPBridge.vue?vue&type=template&id=a0cd2e7e&scoped=true"
import script from "./SIPBridge.vue?vue&type=script&lang=js"
export * from "./SIPBridge.vue?vue&type=script&lang=js"
import style0 from "./SIPBridge.vue?vue&type=style&index=0&id=a0cd2e7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0cd2e7e",
  null
  
)

export default component.exports